<template>
  <div>
    <div class="landNavbar" id="fixed">
      <!-- brand design -->
      <div class="flexNavEmail" id="landingLogo">
        <router-link :to="{ 
            name: 'Landingpage',
          }" class="flexLogo">
          <img
            src="@/assets/landingLogo.svg"
            width="237"
            height="49"
            alt="main page logo"
          />
        </router-link>
      </div>

      <!-- profile design -->
      <div class="flexNavEmail" id="navigation">
        <a class="landingButton" href="#contact">Contact Us</a>
        <!--:to="{
            name: 'Contact',
          }"-->
        <router-link
          class="landingButton"
          :to="{
            name: 'EmailLandingPage',
          }"
          >Schools</router-link
        >
        <router-link
          class="landingButton"
          :to="{
            name: 'Login',
          }"
          >Login</router-link
        >

        <router-link
          class="landingButton"
          :to="{
            name: 'Signup',
          }"
          >Sign up</router-link
        >
        <div class="hamburgerMenu">
          <input id="hamburgerBox" type="checkbox" />

          <span class="hamburgerLayer" id="firstLayer"></span>
          <span class="hamburgerLayer" id="secondLayer"></span>
          <span class="hamburgerLayer" id="thirdLayer"></span>

          <ul id="smallMenu">
            <router-link
              class="smallLandingButton"
              :to="{
                name: 'EmailLandingPage',
              }"
              >Schools</router-link
            >
            <router-link
              class="smallLandingButton"
              :to="{
                name: 'Login',
              }"
              >Login</router-link
            >

            <router-link
              class="smallLandingButton"
              :to="{
                name: 'Signup',
              }"
              >Sign up</router-link
            >

            <div id="contact" class="bottomLanding">
              <div class="totalContact contactLeft">
                <a
                  href="https://apps.apple.com/ca/app/courselnk/id1545799969"
                  class="appstore"
                  target="_blank"
                ></a>
                <a
                  href="https://facebook.com/courselnk"
                  class="facebook"
                  target="_blank"
                ></a>

                <a
                  href="https://instagram.com/courselnk"
                  class="instagram"
                  target="_blank"
                ></a>

                <a
                  href="https://linkedin.com/company/71220107"
                  class="linkedin"
                  target="_blank"
                ></a>
                <a
                  href="mailto:support@courselnk.com"
                  class="email"
                  target="_blank"
                ></a>
              </div>
            </div>
          </ul>
      </div>
      </div>
    </div>

    <div class="center-screen">
      <div class="school-list">
        <div class="interactiveMap">
          <div class="city Montreal">
            <img class="pin" src="@/assets/ELandPin.png"/>
            <div class="secondUni">
              <img class="circle" src="@/assets/ELandconcordia.png"/>
              <p class="uText">Concordia *</p>
            </div>
            <div class="firstUni">
              <img class="circle" src="@/assets/ELandmcgill.png"/>
              <p class="uText">McGill</p>
            </div>
          </div>
          <div class="city Ottawa">
            <img class="pin" src="@/assets/ELandPin.png"/>
            <div class="fifthUni">
              <img class="circle" src="@/assets/ELandontech.png"/>
              <p class="uText">Ontario Tech *</p>
            </div>
            <div class="fourthUni">
              <img class="circle" src="@/assets/ELandtrentu.png"/>
              <p class="uText">TrentU</p>
            </div>
            <div class="thirdUni">
              <img class="circle" src="@/assets/ELandqueens.png"/>
              <p class="uText">Queen's *</p>
            </div>
            <div class="secondUni">
              <img class="circle" src="@/assets/ELandcarleton.png"/>
              <p class="uText">Carleton *</p>
            </div>
            <div class="firstUni">
              <img class="circle" src="@/assets/ELanduottawa.png"/>
              <p class="uText">UOttawa *</p>
            </div>
          </div>
          <div class="city Toronto">
            <img class="pin" src="@/assets/ELandPin.png"/>
            <div class="unis">
              <div class="sixthUni">
                <img class="circle" src="@/assets/ELandbrocku.png"/>
                <p class="uText">BrockU *</p>
              </div>
              <div class="fifthUni">
                <img class="circle" src="@/assets/ELandguelph.png"/>
                <p class="uText">GuephU *</p>
              </div>
              <div class="fourthUni">
                <img class="circle" src="@/assets/ELandryerson.png"/>
                <p class="uText">Ryerson *</p>
              </div>
              <div class="thirdUni">
                <img class="circle" src="@/assets/ELandmcmaster.png"/>
                <p class="uText">McMaster *</p>
              </div>
              <div class="secondUni">
                <img class="circle" src="@/assets/ELandyorku.png"/>
                <p class="uText">York *</p>
              </div>
              <div class="firstUni">
                <img class="circle" src="@/assets/ELanduoft.png"/>
                <p class="uText">UofT *</p>
              </div>
            </div>
          </div>
          <div class="city Vancouver">
            <img class="pin" src="@/assets/ELandPin.png"/>
            <div class="thirdUni">
              <img class="circle" src="@/assets/ELandsimonfraser.png"/>
              <p class="uText">Simon FraserU *</p>
            </div>
            <div class="secondUni">
              <img class="circle" src="@/assets/ELandkwantlen.png"/>
              <p class="uText">Kwantlen Polytechnic *</p>
            </div>
            <div class="firstUni">
              <img class="circle" src="@/assets/ELandubc.png"/>
              <p class="uText">UBC *</p>
            </div>
          </div>
          <div class="city Edmonton">
            <img class="pin" src="@/assets/ELandPin.png"/>
            <div class="firstUni">
              <img class="circle" src="@/assets/ELandualberta.png"/>
              <p class="uText">UAlberta *</p>
            </div>
          </div>
          <div class="city Waterloo">
            <img class="pin" src="@/assets/ELandPin.png"/>
            <div class="fourthUni">
              <img class="circle" src="@/assets/ELanduwindsor.png"/>
              <p class="uText">WindsorU *</p>
            </div> 
            <div class="thirdUni">
              <img class="circle" src="@/assets/ELandwilfrid.png"/>
              <p class="uText">Wilfrid Laurier *</p>
            </div> 
            <div class="secondUni">
              <img class="circle" src="@/assets/ELandwestern.png"/>
              <p class="uText">WesternU</p>
            </div>
            <div class="firstUni">
              <img class="circle" src="@/assets/ELandwaterloo.png"/>
              <p class="uText">Waterloo *</p>
            </div>
          </div>
          <div class="city Calgary">
            <img class="pin" src="@/assets/ELandPin.png"/>
            <div class="secondUni">
              <img class="circle" src="@/assets/ELandmountroyal.png"/>
              <p class="uText">Mount Royal *</p>
            </div>
            <div class="firstUni">
              <img class="circle" src="@/assets/ELanducalgary.png"/>
              <p class="uText">UCalgary *</p>
            </div>
          </div>
          <div class="city Lethbridge">
            <img class="pin" src="@/assets/ELandPin.png"/>
            <div class="firstUni">
              <img class="circle" src="@/assets/ELandlethbridge.png"/>
              <p class="uText">ULethbridge *</p>
            </div>
          </div>
          <div class="city Winnipeg">
            <img class="pin" src="@/assets/ELandPin.png"/>
            <div class="firstUni">
              <img class="circle" src="@/assets/ELandumanitoba.png"/>
              <p class="uText">UManitoba *</p>
            </div>
          </div>
          <div class="city Saskatoon">
            <img class="pin" src="@/assets/ELandPin.png"/>
            <div class="firstUni">
              <img class="circle" src="@/assets/ELandusaska.png"/>
              <p class="uText">USaskatchewan *</p>
            </div>
          </div>
          <div class="city Regina">
            <img class="pin" src="@/assets/ELandPin.png"/>
            <div class="firstUni">
              <img class="circle" src="@/assets/ELanduregina.png"/>
              <p class="uText">URegina *</p>
            </div>
          </div>
          <div class="city Kamloops">
            <img class="pin" src="@/assets/ELandPin.png"/>
            <div class="firstUni">
              <img class="circle" src="@/assets/ELandthompson.png"/>
              <p class="uText">Thompson Rivers *</p>
            </div>
          </div>
          <div class="city Halifax">
            <img class="pin" src="@/assets/ELandPin.png"/>
            <div class="firstUni">
              <img class="circle" src="@/assets/ELanddalhousie.png"/>
              <p class="uText">Dalhousie *</p>
            </div>
          </div>
          <div class="city StJohns">
            <img class="pin" src="@/assets/ELandPin.png"/>
            <div class="firstUni">
              <img class="circle" src="@/assets/ELandmemorialu.png"/>
              <p class="uText">MemorialU *</p>
            </div>
          </div>
          <div class="city Victoria">
            <img class="pin" src="@/assets/ELandPin.png"/>
            <div class="firstUni">
              <img class="circle" src="@/assets/ELanduvictoria.png"/>
              <p class="uText">VictoriaU *</p>
            </div>
          </div>
        </div>
        <div class="nonInteractive">
          <img class="backgroundMap" src="@/assets/ELandCanada.png" />
          <img class="backgroundMapSmall" src="@/assets/ELandSmallCanada.png" />
        </div>

        <form class="submitForm" @submit.prevent="addEmail">
          <h4 class="shrinked">Enter your email to get notified when we expand to your school</h4>

          <select required v-model="university" class="select-css">
            <option value="" disabled selected hidden>Your University...</option>
            <option
              v-for="(school, index) in schools"
              :key="index"
              :value="school"
            >
              {{ school }}
            </option>
          </select>
          <input
            v-model="email"
            type="text"
            placeholder="Email"
            name="email"
            required
          />
          <p>{{ this.feedback }}</p>

          <div class="clearfix">
            <button type="submit" class="emailButton signupbtn">Notify Me</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import db from "@/db";

export default {
  name: "EmailLandingPage",
  data: () => ({
    email: "",
    university: "",
    feedback: "",
    schools: [
      "BrockU",
      "Carleton",
      "Concordia",
      "Dalhousie",
      "Kwantlen Polytechnic",
      "MacEwan",
      "McMaster",
      "Memorial U",
      "Mount Royal",
      "Ontario Tech",
      "Queens",
      "Ryerson",
      "Simon Fraser",
      "Thompson Rivers",
      "UAlberta",
      "UBC",
      "UCalgary",
      "UGuelph",
      "ULethbridge",
      "UManitoba",
      "UOttawa",
      "URegina",
      "USaskatchewan",
      "UofT",
      "UVictoria",
      "UWaterloo",
      "UWindsor",
      "Wilfrid Laurier",
      "York",
    ],
  }),

  methods: {
    addEmail() {
      var re = /\S+@\S+\.\S+/;
      if (re.test(this.email)) {
        db.collection("emails")
          .doc()
          .set({ school: this.university, email: this.email });
        this.email = "";
        this.feedback =
          "We will send you an email as soon as we release at your school!";
      } else {
        this.feedback = "Please enter a valid email";
      }
    },
  },
};
</script>

<style scoped>
h4 {
  font-size: 30px;
  color: #fff;
  font-weight: 500;
}

p {
  font-size: 18px;
  color: #fff;
}

input[type="text"],
input[type="password"] {
  width: 100%;
  padding: 15px;
  margin: -7px 0 22px 0;
  display: inline-block;
  border: none;
  background: #eeeeee;
  border-radius: 6px;
  font-size: 14px;
}
input[type="text"]:focus,
input[type="password"]:focus {
  background-color: #ddd;
  outline: none;
}
#landingLogo {
  min-width: 280px;
  justify-content: center;
}
.landNavbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /*position: fixed;*/
  width: 100%;
  position: relative;
  z-index: 5;
  /*border: #f0f0f0 solid;
  border-width: 10px;
  border-radius: 17px !important;*/
  height: 70px;
}

.hamburgerMenu {
  display: none;
}

.hamburgerLayer {
  display: block;
  position: fixed;
  margin-right: 2px;
  width: 33px;
  height: 2px;
  margin-bottom: 7px;

  background: white;
  /*border-radius: 3px;*/

  z-index: 10;

  transform-origin: 4px 0px;

  transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),
    background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), opacity 0.55s ease;
}

#firstLayer {
  top: 20px;
  right: 20px;
}
#secondLayer {
  top: 30px;
  right: 20px;
}
#thirdLayer {
  top: 40px;
  right: 20px;
}

.hamburgerLayer:first-child {
  transform-origin: 0% 0%;
}

.hamburgerLayer:nth-last-child(2) {
  transform-origin: 0% 100%;
}

/* 
 * Transform all the slices of hamburger
 * into a crossmark.
 */
#hamburgerBox:checked ~ span {
  opacity: 1;
  transform: rotate(45deg) translate(-2px, -1px);
  background: white; /*#232323*/
  z-index: 10;
}

/*
 * But let's hide the middle one.
 */
#hamburgerBox:checked ~ span:nth-last-child(3) {
  opacity: 0;
  transform: rotate(0deg) scale(0.2, 0.2);
}

/*
 * Ohyeah and the last one should go the other direction
 */
#hamburgerBox:checked ~ span:nth-last-child(2) {
  transform: rotate(-45deg) translate(0px, -1px);
}

#hamburgerBox {
  display: block;
  position: fixed;
  width: 40px;
  height: 40px;
  top: 15px;
  right: 15px;

  cursor: pointer;

  opacity: 0; /* hide this */
  z-index: 15; /* and place it over the hamburger */

  -webkit-touch-callout: none;
}

#smallMenu {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  padding: 50px;
  padding-top: 125px;

  background: #0ca69e;
  list-style-type: none;
  -webkit-font-smoothing: antialiased;
  /* to stop flickering of text in safari */
  z-index: 6;
  transform-origin: 0% 0%;
  transform: translate(0, -150vh);

  transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1);
}

.hamburgerMenu #hamburgerBox:checked ~ ul {
  transform: none;
}

.smallLandingButton {
  font-family: Inter;
  font-weight: bold;
  font-size: 30px;
  color: white;
  margin: 10px;
}
.smallLandingButton:hover {
  color: #00ddd2;
}

.linkedin {
  padding: 30px;
  max-width: 60px;
  background-image: url("../../assets/linkedin.svg");
  background-repeat: no-repeat;
  background-position: center;
  margin: 10px;
}
.linkedin:hover {
  background-image: url("../../assets/linkedinHover.svg");
}
.instagram {
  padding: 30px;
  max-width: 60px;
  background-image: url("../../assets/instagram.svg");
  background-repeat: no-repeat;
  background-position: center;
  margin: 10px;
}
.instagram:hover {
  background-image: url("../../assets/instagramHover.svg");
}
.facebook {
  padding: 30px;
  max-width: 60px;
  background-image: url("../../assets/facebook.svg");
  background-repeat: no-repeat;
  background-position: center;
  margin: 10px;
}
.facebook:hover {
  background-image: url("../../assets/facebookHover.svg");
}
.appstore {
  padding: 30px;
  max-width: 60px;
  background-image: url("../../assets/app.svg");
  background-repeat: no-repeat;
  background-position: center;
  margin: 10px;
}
.appstore:hover {
  background-image: url("../../assets/appHover.svg");
}
.email {
  padding: 30px;
  max-width: 60px;
  background-image: url("../../assets/email.svg");
  background-repeat: no-repeat;
  background-position: center;
  margin: 10px;
}
.email:hover {
  background-image: url("../../assets/emailHover.svg");
}

.totalContact {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.contactLeft {
  justify-content: flex-start !important;
}

.emailButton {
  background-color: #0a7c76;
  color: white;
  padding: 10px 20px;
  margin: 8px 0;
  border-radius: 10px;
  cursor: pointer;
  width: 100%;
  border: none;
  opacity: 0.9;
  font: 24px bold Arial, Helvetica, sans-serif;
}
.emailButton:hover {
  opacity: 1;
}

.school-list {
  text-align: left;
  width: 100%;
}

.center-screen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  max-height: 100vh;
  min-height: 100vh;
  background-color: #0ca69f;
  overflow: hidden;
}
.select-css {
  font-size: 14px;
  width: 100%;
  margin: 20px 0;
  padding: 15px;
  display: inline-block;
  border: none;
  background: #eeeeee;
  border-radius: 5px;
  appearance: none;
  background-image: url("../../assets/dropdown.png"); /*linear-gradient(to bottom, #ffffff 0%, #e5e5e5 100%)*/
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
}

#fixed {
  position: fixed;
  background-color: #0ca69e00; /*0CA69F   0ca69e83*/
  border: none;
  box-shadow: none;
  padding: 10px;
  padding-left: 5%;
  padding-right: 5%;
}
.landNavbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /*position: fixed;*/
  width: 100%;
  position: relative;
  z-index: 5;
  /*border: #f0f0f0 solid;
  border-width: 10px;
  border-radius: 17px !important;*/
  height: 70px;
  background-color: #0ca69f;
}
.flexNavEmail {
  background-color: transparent;
  transition: all 0.2s ease-in-out;
  display: flex;
  align-items: center !important;
  justify-content: center;
}
.landingButton {
  padding: 5px 12px 5px 12px;
  margin-right: 5px;
  border-radius: 50px;
  color: white;
  border: solid 1px #11cdc4;
  transition: 0.3s;
}
.landingButton:hover {
  background-color: #11cdc4 !important;
}
.interactiveMap {
  position: fixed;
  z-index: 2;
  left: 0;
  /*top: 0;
  bottom: 0;*/
  right: 50%;
  justify-content: center;
  align-items: center;
  /*background-image: url("../../assets/ELandCanada.png");
  background-repeat: no-repeat;
  background-position: 50% 50%;*/
  min-height: 580px;
  max-height: 580px;
  /*padding-top: 600px;*/
  padding-top: 210px;
}
.nonInteractive {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.backgroundMap {
  width: auto;
  z-index: 1;
  min-height: 580px;
  max-height: 580px;
}
.backgroundMapSmall {
  display: none;
}
.submitForm {
  position: fixed;
  right: 50px;
  bottom: 0;
  top: 0;
  left: 800px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.city:hover .firstUni {
  transform: translate(0, -35px);
}
.city:hover .secondUni {
  transform: translate(0, -70px);
}
.city:hover .thirdUni {
  transform: translate(0, -105px);
}
.city:hover .fourthUni {
  transform: translate(0, -140px);
}
.city:hover .fifthUni {
  transform: translate(0, -175px);
}
.city:hover .sixthUni {
  transform: translate(0, -210px);
}
.city:hover .uText {
  display: block;
}
.Toronto {
  position: fixed;
  z-index: 2;
  padding-left: 460px;
}
.Vancouver {
  position: absolute;
  z-index: 2;
  padding-left: 55px;
  margin-top: -130px;
}
.Waterloo {
  position: absolute;
  z-index: 2;
  padding-left: 440px;
  margin-top: 15px;
}
.Edmonton {
  position: absolute;
  z-index: 2;
  padding-left: 155px;
  margin-top: -125px;
}
.Calgary {
  position: absolute;
  z-index: 2;
  padding-left: 140px;
  margin-top: -100px;
}
.Lethbridge {
  position: absolute;
  z-index: 2;
  padding-left: 150px;
  margin-top: -80px;
}
.Ottawa {
  position: absolute;
  z-index: 2;
  margin-top: -15px;
  padding-left: 475px;
}
.Montreal {
  position: absolute;
  z-index: 2;
  margin-top: -25px;
  padding-left: 490px;
}
.Winnipeg {
  position: absolute;
  z-index: 2;
  margin-top: -65px;
  padding-left: 275px;
}
.Saskatoon {
  position: absolute;
  z-index: 2;
  margin-top: -100px;
  padding-left: 200px;
}
.Regina {
  position: absolute;
  z-index: 2;
  margin-top: -80px;
  padding-left: 210px;
}
.Kamloops {
  position: absolute;
  z-index: 2;
  padding-left: 100px;
  margin-top: -110px;
}
.Halifax {
  position: absolute;
  z-index: 2;
  padding-left: 600px;
  margin-top: -60px;
}
.StJohns {
  position: absolute;
  z-index: 2;
  padding-left: 670px;
  margin-top: -150px;
}
.Victoria {
  position: absolute;
  z-index: 2;
  padding-left: 45px;
  margin-top: -100px;
}
.uText {
  color: white;
  background: #056d6885;
  border-radius: 10px;
  font-size: 20px;
  display: none;
  margin-left: 35px;
  width: max-content;
  padding-left: 10px;
  padding-right: 10px;
}
.unis {
  z-index: 2;
}
.pin {
  position: absolute;
  z-index: 3;
  width: 30px;
}
.firstUni {
  content: '/A';
  position: absolute;
  transition: all ease-in-out .5s;
  z-index: 2;
  width: fit-content;
  height: 10px;
}
.secondUni {
  content: '/A';
  position: absolute;
  transition: all ease-in-out .5s;
  z-index: 2;
  width: fit-content;
  height: 10px;
}
.thirdUni {
  content: '/A';
  position: absolute;
  transition: all ease-in-out .5s;
  z-index: 2;
  width: fit-content;
  height: 10px;
}
.fourthUni {
  content: '/A';
  position: absolute;
  transition: all ease-in-out .5s;
  z-index: 2;
  width: fit-content;
  height: 10px;
}
.fifthUni {
  content: '/A';
  position: absolute;
  transition: all ease-in-out .5s;
  z-index: 2;
  width: fit-content;
  height: 10px;
}
.sixthUni {
  content: '/A';
  position: absolute;
  transition: all ease-in-out .5s;
  z-index: 2;
  width: fit-content;
  height: 10px;
}
.firstUni:after {
  content: 'HHH';
  opacity: 0;
}
.secondUni:after {
  content: 'HHH';
  opacity: 0;
}
.thirdUni:after {
  content: 'HHH';
  opacity: 0;
}
.fourthUni:after {
  content: 'HHH';
  opacity: 0;
}
.fifthUni:after {
  content: 'HHH';
  opacity: 0;
}
.sixthUni:after {
  content: 'HHH';
  opacity: 0;
}
.circle {
  position: absolute;
  z-index: 2;
  width: 30px;
}

@media only screen and (max-width: 1030px) {
  .interactiveMap {
    position: fixed;
    z-index: 2;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    padding-top: 605px;
    display: none;
  }
  .nonInteractive {
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }
  .submitForm {
    position: fixed;
    right: 0%;
    left: 0%;
    bottom:0%;
    width:100%;
    top: 70%;
    min-height: 260px;
    max-height: 260px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 3;
  }
  .backgroundMap {
    display: none;
  }
  .backgroundMapSmall {
    display: block;
    width: 700px;
    z-index: 1;
    min-width: 700px !important;
  }
  .shrinked {
    display: none;
  }
}
@media only screen and (max-width: 772px) {
  .hamburgerMenu {
    display: block;
  }
  .landingButton {
    display: none;
  }
  .landNavbar {
    justify-content: space-between;
  }
  .shrinked {
    display: none;
  }
}
@media only screen and (max-width: 600px) {
  .landNavbar {
    padding: 10px !important;
  }
  .submitForm {
    position: fixed;
    right: 0%;
    left: 0%;
    bottom:0%;
    width:100%;
    top: 65%;
    min-height: 260px;
    max-height: 260px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 3;
  }
}
</style>
